import { VTreeContext } from './context';

export const useVTreeContext = VTreeContext.hook;
